export const isActivePath = (pathname: string, to: string): boolean => {
  const stripped = to.endsWith('/') && to.length > 1 ? to.slice(0, -1) : to
  return pathname === stripped || pathname.startsWith(`${stripped}/`)
}
